import { createForm } from 'effector-forms'
import { required } from '~/shared/validators'

// sign in form
export const signInForm = createForm({
  fields: {
    username: {
      init: '' as string,
      rules: [required()],
    },
    password: {
      init: '' as string,
      rules: [required()],
    },
  },
  validateOn: ['submit'],
})
